export const engagementModelContent = {
  heading: "Seamless Collaboration, ",
  darkHeading: "Proven Delivery, Measurable Results",
  subheading:
    "Choosing the right engagement model is crucial. We offer flexible options, from dedicated development teams to project-based partnerships, ensure transparency, seamless collaboration, & maximum efficiency aligned with your AI, web, or IT project goals.",
  models: [
    {
      index: "1.",
      title: "Staff Augmentation",
      description:
        "Easily scale resources with our staff augmentation & team extension model, adding skilled professionals to fill gaps & provide precise expertise for projects.",
      icon: "/images/engagement-model-gifs/hourly-icon.svg",
      iconWidth: 40,
      bestForText: ["Startups", "SMBs", "Fast-Growing Companies", "Teams Needing Extra Hands Quickly"]
    },
    {
      index: "2.",
      title: "Dedicated Teams",
      description:
        "A full-time dedicated development team leveraging cognitive technologies, delivering tailored solutions aligned with your project goals & business success.",
      icon: "/images/engagement-model-gifs/price-icon.svg",
      iconWidth: 35,
      bestForText: ["Enterprises", "Product Teams", "Long-Term Projects", "Companies Needing Continuous Support"]
    },
    {
      index: "3.",
      title: "Turnkey Project Solutions",
      description:
        "Our project-based model ensures tailored solutions, seamless teamwork, & focused execution to meet specific goals within defined timelines.",
      icon: "/images/engagement-model-gifs/retainer-icon.svg",
      iconWidth: 40,
      bestForText: ["MVPs", "Fixed-Scope Projects", "Short-Term Deliverables", "Businesses Wanting Predictable Timelines & Costs"]
    },
  ],
  cta: {
    text: "Get Your Customized Solution",
    button: "Find the Right Model",
    link: "/contact-us",
  },
};
